import api from "~/api/api.js";
import {Product as ProductEntity} from "~/dto/Product.js";
import type {ProductListInterface} from "~/interfaces/ProductListInterface";
import type {ProductListInterface as ProductListRequest} from "~/api/interfaces/ProductListInterface";
import {Filter} from "~/dto/Filter";

export class Product {

    static async getInfo(id: number): Promise<ProductEntity> {
        const info = await api("/products/info", {
            id,
            variantMatrix: 1,
            loadSets: 1,
            fetchClosest: 1,
            showTree: 1
        });
        return ProductEntity.createFromObj(info);
    }

    static async get(params: ProductListRequest = {}): Promise<ProductListInterface> {
        const defaultParams: ProductListRequest = {
            page: 1,
            limit: 20
        };
        params = {...defaultParams, ...params};

        const data = await api("/products/index", params);

        return {
            count: data.count,
            products: data.products.map((el: Object) => ProductEntity.createFromObj(el))
        }
    }

    static async getVariants(ids: Array<Number>): Promise<ProductListInterface> {
        const data = await api("/products/variants", {id: ids});
        data.products = data.products.map((el: Object) => ProductEntity.createFromObj(el));

        return data;
    }

    static async getFilters(): Promise<Array<Filter>> {
        const data = await api("/taxonomies/filters");
        return data.map((el: Object) => Filter.createFromObj(el));
    }

}